module.exports = __webpack_public_path__ + "img/ruishishu.0c393594.png";